import { EMAIL_REGEX } from "@/constants/regex";

type ErrorToastProps = {
  title: string;
  message: string;
};

const EMAIL_RULES = {
  pattern: {
    value: EMAIL_REGEX,
    message:
      "The email you entered is invalid. Please enter a valid email address."
  }
};

export const LOGIN_RULES = {
  email: EMAIL_RULES
};

export const RESET_PASSWORD_RULES = {
  email: EMAIL_RULES
};

export const ERROR_LOGIN_MAPPING = {
  401: {
    title: "Invalid Email or Password",
    message: "Please enter a valid email or password and try again."
  },
  429: {
    title: "Too Many Failed Login Attempts",
    message: "Please try again after 15 minutes." // BE is set to 15 minutes to allow for retrying
  },
  default: {
    title: "Something Went Wrong",
    message:
      "Sorry, we're experiencing an issue while processing your request. Please try again."
  }
};

export const LoginErrorToast = ({ title, message }: ErrorToastProps) => (
  <div>
    <h1 className="text-txtHeading font-bold">{title}</h1>
    <span className="text-txtHeading text-sm">{message}</span>
  </div>
);
